import { DiamondShapeButton } from 'common/alchemyComponents/DiamondShapeButton';

import * as Styled from './RewardButton.styled';

export function RewardButton({
  text,
  iconUrl,
  ariaLabel,
  onClick = () => {},
}: RewardButtonProps) {
  return (
    <DiamondShapeButton
      size={140}
      onClick={onClick}
      aria-label={ariaLabel}
      priority="secondary"
      palette="expressiveInformative"
      type="button"
    >
      <Styled.ButtonImage src={iconUrl} alt="" />
      <Styled.Description>{text}</Styled.Description>
    </DiamondShapeButton>
  );
}

interface RewardButtonProps {
  text?: string;
  iconUrl?: string;
  ariaLabel?: string;
  onClick?: () => void;
}
